import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import * as ROUTES from 'src/constants/routes'
import BarsIcon from 'src/assets/icons/bars.svg'

import { StyledHeader, StyledNavBar } from './styled'

interface Props {
  title?: string
}

export const Header: FC<Props> = ({ title = 'ConnectUp' }) => {
  const navigate = useNavigate()

  const handleSettingsClick = () => {
    void navigate(ROUTES.PRIVATE_SETTINGS)
  }

  return (
    <StyledHeader as="header" role="banner">
      <StyledNavBar
        back={null}
        left={<div style={{ width: '56px' }} />}
        right={
          <button
            type="button"
            onClick={handleSettingsClick}
            style={{
              background: 'none',
              border: 'none',
              padding: '8px',
              cursor: 'pointer',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '40px',
              minHeight: '40px',
            }}
            aria-label="Open settings"
          >
            <img src={BarsIcon} alt="" width={24} height={24} />
          </button>
        }
      >
        <h1 style={{ margin: 0, fontSize: 'inherit', fontWeight: 'inherit' }}>{title}</h1>
      </StyledNavBar>
    </StyledHeader>
  )
}
